var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.249,
    height: 14.249,
    viewBox: "0 0 14.249 14.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#33cdd1;stroke:#33cdd1;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.211,6.337h-5.8V.537a.537.537,0,1,0-1.074,0v5.8H.537a.537.537,0,1,0,0,1.074h5.8v5.8a.537.537,0,1,0,1.074,0v-5.8h5.8a.537.537,0,1,0,0-1.074Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.ce52b56d9197a8aeed5fb18e9af457f4.svg";
export { ForwardRef as ReactComponent };